export default __webpack_public_path__ + "static/media/LOGO_GMI_aero.68e6db14.png";